const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => {
      this.focusOnCartDrawer();
    }, { once: true });

    bodyScroll.lock(this.querySelector('[role="dialog"]'));


    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').style.opacity = '0';
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));
  

    
    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').removeAttribute('style');
    }
  }

  



  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          response.sections[section.section],
          section.selector
        );
      }
    });
    
    // Update cart title using the updated cart counter
    this.updateCartTitle();
    
    // Initialize shipping bars after content is rendered
    this.#initializeShippingBars();
    
    // Dispatch cart updated event with cart data
    this.#dispatchCartUpdate(response);
    
    if (!open) {
      return;
    }

    this.open();
  }

  #initializeShippingBars() {
    // Find all shipping bars in the rendered content
    const shippingBars = this.querySelectorAll('shipping-bar');
    
    shippingBars.forEach(shippingBar => {
      // Force check cart state and initialize if needed
      if (shippingBar.checkCartStateAndInitialize) {
        shippingBar.checkCartStateAndInitialize();
      }
    });
  }

  #dispatchCartUpdate(response) {
    // Dispatch cart update event with detailed information
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: response,
        source: 'cart-drawer'
      }
    }));
  }

  updateCartTitle() {
    // console.log('updateCartTitle');
    const cartTitle = document.querySelector('.cart-drawer__title');
    const cartCountBadge = document.querySelector('.cart-count-badge');
    
    if (cartTitle && cartCountBadge) {
      // Extract the count from the cart counter badge
      let itemCount = cartCountBadge.textContent.trim();
      
      // Handle the 99+ case
      if (itemCount === '+') {
        itemCount = '99+';
      } else if (itemCount === '') {
        // Badge is hidden when count is 0
        itemCount = '0';
      }
      
      // Replace the count in parentheses
      const currentText = cartTitle.textContent;
      const newText = currentText.replace(/\(\d+\)/, `(${itemCount})`);
      cartTitle.textContent = newText;
    } else if (cartTitle && !cartCountBadge) {
      // If badge is hidden (count is 0), set count to 0
      const currentText = cartTitle.textContent;
      const newText = currentText.replace(/\(\d+\)/, '(0)');
      cartTitle.textContent = newText;
    }
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer');
    if (cartDrawer) {
      // cartDrawer.setAttribute('tabindex', '0');
      cartDrawer.focus();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    // Call the parent method first
    super.updateQuantity(line, quantity, name);
    
    // Then update the cart title after a short delay to ensure sections are rendered
    setTimeout(() => {
      this.updateCartTitle();
      this.#handleShippingBarsAfterUpdate();
    }, 100);
  }

  #handleShippingBarsAfterUpdate() {
    // Find and re-initialize shipping bars after quantity updates
    const shippingBars = document.querySelectorAll('shipping-bar');
    
    shippingBars.forEach(shippingBar => {
      if (shippingBar.checkCartStateAndInitialize) {
        shippingBar.checkCartStateAndInitialize();
      }
    });
  }

  updateCartTitle() {
    const cartTitle = document.querySelector('.cart-drawer__title');
    const cartCountBadge = document.querySelector('.cart-count-badge');
    
    if (cartTitle && cartCountBadge) {
      // Extract the count from the cart counter badge
      let itemCount = cartCountBadge.textContent.trim();
      
      // Handle the 99+ case
      if (itemCount === '+') {
        itemCount = '99+';
      } else if (itemCount === '') {
        // Badge is hidden when count is 0
        itemCount = '0';
      }
      
      // Replace the count in parentheses
      const currentText = cartTitle.textContent;
      const newText = currentText.replace(/\(\d+\)/, `(${itemCount})`);
      cartTitle.textContent = newText;
    } else if (cartTitle && !cartCountBadge) {
      // If badge is hidden (count is 0), set count to 0
      const currentText = cartTitle.textContent;
      const newText = currentText.replace(/\(\d+\)/, '(0)');
      cartTitle.textContent = newText;
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
